import type { Types as SduiTypes } from '../types';
import type { OutTypes } from './schedules';

export default (
  holiday: SduiTypes.holiday
): OutTypes.exception => {
  return {
    // ids: holiday.id
  };
};
